import type {
  SaveVolatilityDecisionRequest,
  SaveVolatilityDecisionResponse,
  VolatilityChartStateResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getVolatilityChartState(instanceId: string, goalId: string) {
  return get<VolatilityChartStateResponse>(
    `${BASE}/${instanceId}/goals/${goalId}/volatility-chart`,
  );
}

export function saveVolatilityChartDecision(
  instanceId: string,
  goalId: string,
  request: SaveVolatilityDecisionRequest,
) {
  return post<SaveVolatilityDecisionResponse>(
    `${BASE}/${instanceId}/goals/${goalId}/volatility-chart/decision`,
    request satisfies SaveVolatilityDecisionRequest,
  );
}
